// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { myAccountTableScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = {
    variant: "link" as any,
    icon: {
        src: RefreshCcw,
        position: "left",
    },
    css: css`
        margin-right: auto;
    `,
};

orderHistoryTableStyles.reorderButtonSpinner = {
    size: 20,
    css: css`
        margin-left: auto;
        margin-right: auto;
        display: block;
    `,
};

orderHistoryTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

orderHistoryTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};


orderHistoryTableStyles.orderTotalCells = {
    css: css`
        text-align: left;
    `,
}

orderHistoryTableStyles.container = {
    css: css`
        ${myAccountTableScrollbar}
    `,
};
